import React from "react";
import { Container, Row, Col } from "react-bootstrap";

import MapChart from "../components/MapChart";

import SeresLatam from "../images/sereslatam_white.png";

const Hero = () => {
    return (
        <section className="hero section" id="home">
            <Container>
                <Row className="align-items-center justify-content-center contenido">
                    <Col md={4} lg={4} sm={12} xs={12} className="white content">
                        <img src={SeresLatam} alt="logo sereslatam" className="img img-fluid" width={300} />
                        <br/><br/><br/>
                        <p className="hero-text">
                            <strong>Te acompañamos en la construcción de un futuro sólido.</strong>&nbsp;
                            Nuestro servicio, nos convierte en el socio ideal para organizaciones que desean&nbsp;
                            <strong>anticiparse, adaptarse y prosperar.</strong>
                        </p>
                        <br/>
                        <a href="#nuestroservicio" className="btn boton-hero me-2">Nuestro servicio</a>
                        <a href="#newsletter" className="btn boton-hero-secondary">Newsletter</a>
                    </Col>
                    <Col md={8} lg={8} sm={12} xs={12} className="mt-0 d-none d-lg-block d-md-block">
                        <MapChart />
                    </Col>
                </Row>
            </Container>
        </section>
    )
}

export default Hero;